// Kalan İstanbul Avrupa Yakası ilçeleri için dropdown/accordion yapılı sidebarlar hazırlanıyor.
// Format: Tekli açılır başlık (semt), altında mahalle linkleri ve açıklamaları olacak.
// Bu yapıda sadece dropdown davranışı eklenecek, Şişli örneğinde olduğu gibi her mahalle aynı seviyede olacak.

// Örnek: BuyukcekmeceSidebar.jsx

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  {
    label: "Atatürk Mahallesi Halı Yıkama",
    path: "/buyukcekmece/ataturk-hali-yikama",
    description:
      "Atatürk Mahallesi’nde halılarınız modern makinelerde, hijyenik koşullarda temizlenir ve kapınıza teslim edilir."
  },
  {
    label: "Fatih Mahallesi Halı Yıkama",
    path: "/buyukcekmece/fatih-hali-yikama",
    description:
      "Fatih Mahallesi’nde bireysel ve kurumsal müşterilere özel profesyonel halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Mimaroba Mahallesi Halı Yıkama",
    path: "/buyukcekmece/mimaroba-hali-yikama",
    description:
      "Mimaroba’da halılarınız el değmeden, çevre dostu ürünlerle yıkanır ve steril paketle geri teslim edilir."
  },
  {
    label: "Kumburgaz Halı Yıkama",
    path: "/buyukcekmece/kumburgaz-hali-yikama",
    description:
      "Kumburgaz semtinde halılarınızı kapınızdan alıyor, garantili şekilde temizleyerek teslim ediyoruz."
  }
];

const BuyukcekmeceSidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">BÜYÜKÇEKMECE SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm border border-gray-200">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex justify-between items-center px-3 py-2 text-red-800 font-bold hover:bg-red-100 rounded-md"
        >
          Hizmet Bölgeleri {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </button>

        {isOpen && (
          <div className="mt-2 space-y-3">
            {ServiceArea.map((area, index) => (
              <div key={index}>
                <Link
                  to={area.path}
                  className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                    location.pathname === area.path
                      ? "bg-red-600 text-white"
                      : "text-red-900 hover:bg-green-100 hover:text-red-800"
                  }`}
                >
                  {area.label}
                </Link>
                <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BuyukcekmeceSidebar;
